// extracted by mini-css-extract-plugin
module.exports = {"mainPic":"pictures_mainPic__3YY9X","pic":"pictures_pic__3Aiwz","activePic":"pictures_activePic__1iP-m"};